module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_j_normal.daf80b22.png";